import { OFFER_KIND } from '../../../../../../views/menu/offers/constants';

export default {
  title: 'Créer une nouvelle offre',
  subtitle: 'Comment le client obtient-il un article gratuit ?',
  validation: {
    required: "Veuillez sélectionner un type d'offre",
  },
  types: {
    [OFFER_KIND.PERCENTAGE_OFF_BY_MIN_SPEND_VALUE]: {
      name: 'Valeur totale de la commande',
      description: 'Ex. : 10 % de réduction sur votre commande dès 20 {{currency}} dépensés',
    },
    [OFFER_KIND.PERCENTAGE_OFF_BY_PRODUCTS]: {
      name: 'Articles sélectionnés',
      description: 'Ex. : 10 % de réduction sur les pizzas 30 cm.',
    },
    [OFFER_KIND.AMOUNT_OFF_BY_PRODUCTS]: {
      name: 'Articles sélectionnés',
      description: 'Ex. : 1 {{currency}} de réduction sur les pizzas 30 cm.',
    },
    [OFFER_KIND.AMOUNT_OFF_BY_MIN_SPEND_VALUE]: {
      name: 'Valeur totale de la commande',
      description: 'Ex. : 1 {{currency}} de réduction sur votre commande dès 20 {{currency}} dépensés',
    },
    [OFFER_KIND.BOGO]: {
      name: '1 acheté, 1 offert',
      description: 'Ex. : Achetez 1 pizza, obtenez une autre pizza gratuite. La moins chère est remisée.',
    },
    [OFFER_KIND.BOGO_HALF_PRICE]: {
      name: '1 acheté, 1 à moitié prix',
      description: 'Ex. : Achetez 1 pizza, obtenez une autre pizza à moitié prix. La moins chère est remisée.',
    },
    [OFFER_KIND.FREE_ITEM_BY_PRODUCTS]: {
      name: 'En achetant un autre article',
      description: 'Ex. : Obtenez une boisson offerte avec votre repas.',
    },
    [OFFER_KIND.FREE_ITEM_BY_MIN_SPEND_VALUE]: {
      name: 'En dépensant un montant fixe de {{currency}}',
      description: 'Ex. : Obtenez un dessert offert dès 20 {{currency}} dépensés.',
    },
  },
};
